import React, { Component } from 'react'
import SimpleTabs from './components/ApprovedListTabPanel';

class ApprovedListTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default ApprovedListTab
  